// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Key, KeyT, verifyKey } from "./key";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Bulk operation request for POST /keys/bulk.
 *
 * All create/update/delete ops apply to the same adapter. The server
 * runs the whole thing in a single DB transaction — either every
 * operation succeeds or none do. Non-existent delete IDs or mismatched
 * adapter_id on create/update items cause the transaction to roll back.
 */
export class BulkKeyRequest implements flatbuffers.IUnpackableObject<BulkKeyRequestT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): BulkKeyRequest {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsBulkKeyRequest(bb: flatbuffers.ByteBuffer, obj?: BulkKeyRequest): BulkKeyRequest {
    return (obj || new BulkKeyRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsBulkKeyRequest(
    bb: flatbuffers.ByteBuffer,
    obj?: BulkKeyRequest,
  ): BulkKeyRequest {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new BulkKeyRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  /**
   * Adapter scope — every Key in `create` and `update` must carry
   * this same adapter_id. Extra safety check to prevent cross-adapter
   * drift from a buggy client.
   */
  adapterId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Keys to create. The `id` field on each Key is ignored — the
   * server assigns fresh UUIDs and returns them in the response's
   * `created_ids` in the same order as this array.
   */
  create(index: number, obj?: Key): Key | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Key()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  createLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Keys to update. The `id` field MUST be populated and must
   * reference an existing key on the target adapter.
   */
  update(index: number, obj?: Key): Key | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Key()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  updateLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * IDs of keys to soft-delete. Must belong to the target adapter.
   */
  delete_(index: number, obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new Uuid()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  deleteLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startBulkKeyRequest(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addAdapterId(builder: flatbuffers.Builder, adapterIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, adapterIdOffset, 0);
  }

  static addCreate(builder: flatbuffers.Builder, createOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, createOffset, 0);
  }

  static createCreateVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startCreateVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addUpdate(builder: flatbuffers.Builder, updateOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, updateOffset, 0);
  }

  static createUpdateVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startUpdateVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addDelete(builder: flatbuffers.Builder, delete_Offset: flatbuffers.Offset) {
    builder.addFieldOffset(3, delete_Offset, 0);
  }

  static createDeleteVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startDeleteVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endBulkKeyRequest(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // adapter_id
    return offset;
  }

  static createBulkKeyRequest(
    builder: flatbuffers.Builder,
    adapterIdOffset: flatbuffers.Offset,
    createOffset: flatbuffers.Offset,
    updateOffset: flatbuffers.Offset,
    delete_Offset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    BulkKeyRequest.startBulkKeyRequest(builder);
    BulkKeyRequest.addAdapterId(builder, adapterIdOffset);
    BulkKeyRequest.addCreate(builder, createOffset);
    BulkKeyRequest.addUpdate(builder, updateOffset);
    BulkKeyRequest.addDelete(builder, delete_Offset);
    return BulkKeyRequest.endBulkKeyRequest(builder);
  }

  unpack(): BulkKeyRequestT {
    return new BulkKeyRequestT(
      this.adapterId() !== null ? this.adapterId()!.unpack() : null,
      this.bb!.createObjList<Key, KeyT>(this.create.bind(this), this.createLength()),
      this.bb!.createObjList<Key, KeyT>(this.update.bind(this), this.updateLength()),
      this.bb!.createObjList<Uuid, UuidT>(this.delete_.bind(this), this.deleteLength()),
    );
  }

  unpackTo(_o: BulkKeyRequestT): void {
    _o.adapterId = this.adapterId() !== null ? this.adapterId()!.unpack() : null;
    _o.create = this.bb!.createObjList<Key, KeyT>(this.create.bind(this), this.createLength());
    _o.update = this.bb!.createObjList<Key, KeyT>(this.update.bind(this), this.updateLength());
    _o.delete_ = this.bb!.createObjList<Uuid, UuidT>(this.delete_.bind(this), this.deleteLength());
  }

  unpackFields(...fields: string[]): BulkKeyRequestT {
    const t = new BulkKeyRequestT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("adapter_id")) {
      t.adapterId = this.adapterId() !== null ? this.adapterId()!.unpack() : null;
    }
    if (fieldSet.has("create")) {
      t.create = this.bb!.createObjList<Key, KeyT>(this.create.bind(this), this.createLength());
    }
    if (fieldSet.has("update")) {
      t.update = this.bb!.createObjList<Key, KeyT>(this.update.bind(this), this.updateLength());
    }
    if (fieldSet.has("delete")) {
      t.delete_ = this.bb!.createObjList<Uuid, UuidT>(this.delete_.bind(this), this.deleteLength());
    }
    return t;
  }
}

export class BulkKeyRequestT implements flatbuffers.IGeneratedObject {
  constructor(
    public adapterId: UuidT | null = null,
    public create: KeyT[] = [],
    public update: KeyT[] = [],
    public delete_: UuidT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.adapterId === null || this.adapterId === undefined) {
      throw new Error('Required field "adapter_id" is not set');
    }
    const adapterId = this.adapterId !== null ? this.adapterId!.pack(builder) : 0;
    const create = BulkKeyRequest.createCreateVector(
      builder,
      builder.createObjectOffsetList(this.create),
    );
    const update = BulkKeyRequest.createUpdateVector(
      builder,
      builder.createObjectOffsetList(this.update),
    );
    const delete_ = BulkKeyRequest.createDeleteVector(
      builder,
      builder.createObjectOffsetList(this.delete_),
    );

    return BulkKeyRequest.createBulkKeyRequest(builder, adapterId, create, update, delete_);
  }

  clone(): BulkKeyRequestT {
    const obj = new BulkKeyRequestT();
    obj.adapterId = this.adapterId !== null ? this.adapterId!.clone() : null;
    obj.create = this.create.map((e) => e.clone());
    obj.update = this.update.map((e) => e.clone());
    obj.delete_ = this.delete_.map((e) => e.clone());
    return obj;
  }

  equals(other: BulkKeyRequestT): boolean {
    if (this.adapterId !== null && other.adapterId !== null) {
      if (!this.adapterId!.equals(other.adapterId!)) return false;
    } else if (this.adapterId !== other.adapterId) return false;
    if (this.create.length !== other.create.length) return false;
    for (let i = 0; i < this.create.length; i++) {
      const a = this.create[i];
      const b = other.create[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.update.length !== other.update.length) return false;
    for (let i = 0; i < this.update.length; i++) {
      const a = this.update[i];
      const b = other.update[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.delete_.length !== other.delete_.length) return false;
    for (let i = 0; i < this.delete_.length; i++) {
      const a = this.delete_[i];
      const b = other.delete_[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyBulkKeyRequest(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "adapter_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyKey);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyKey);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyUuid);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
